import React from 'react';

const FaqScreen = () => {
	return <div>FaqScreen</div>;
};

export default FaqScreen;
